<template>
  <div></div>
</template>
<script>
export default {
  name: 'review-detail',
  computed: {
    reviewDetail() {
      return this.$store.state.reviewDetail;
    },
    isHaveReviewDetail() {
      return Boolean(Object.keys(this.$store.state.reviewDetail).length);
    },
    url() {
      const { slug } = this.$options.filters;
      if (this.isHaveReviewDetail) {
        const { product } = this.reviewDetail;
        const isHaveDefaultCategory =
          product &&
          Object.keys(product).length &&
          product.default_category &&
          Object.keys(product.default_category).length;
        const category = isHaveDefaultCategory ? slug(product.default_category.name) : 'default';
        return `/product/${category}/${product.id}-${slug(product.name)}`;
      }
      return encodeURI(`/${window.location.pathname}`);
    },
  },
  created() {
    try {
      this.getReviewDetail()
        .then((res) => this.$store.commit('setReviewDetail', res))
        .then(() => {
          if (this.isHaveReviewDetail) {
            this.$router.replace({ path: this.url });
          } else {
            this.$router.push({ name: 'NotFound' });
          }
        });
    } catch (err) {
      console.error(err);
    }
  },
  mounted() {},
  methods: {
    getReviewDetail() {
      return this.$MS_SOCO_PUBLIC_API_URL
        .get(`/reviews`, {
          params: {
            filter: {
              _id: this.$route.params.id,
            },
            limit: 1,
          },
        })
        .then((res) => res.data.data[0] || {})
        .catch(() => ({}));
    },
  },
};
</script>
